import axios from 'axios';
import { getIdColumnFromTable } from './utils';

type ApiClientConfig = {
  laravelBeHostUrl: string;
  /**
   * Resolved per request rather than captured once. This client is long-lived (one per connector,
   * i.e. one per session) while a Clerk template token expires within the hour, so a header baked
   * in at construction time starts 401-ing mid-session — and because uploads always retry the
   * oldest transaction first, that single expired token stalls the entire CRUD queue.
   */
  getAuthToken: () => Promise<string>;
};

export class ApiClient {
  private readonly baseUrl: string;
  private readonly getAuthToken: () => Promise<string>;

  constructor(config: ApiClientConfig) {
    this.baseUrl = config.laravelBeHostUrl;
    this.getAuthToken = config.getAuthToken;
  }

  private async requestConfig() {
    return {
      headers: {
        'Content-Type': `application/json`,
        Authorization: `Bearer ${await this.getAuthToken()}`,
      },
    };
  }

  async update(data: any, tableName: string): Promise<void> {
    await axios.patch(`${this.baseUrl}/api/${tableName}`, data, await this.requestConfig());
  }

  async upsert(data: any, tableName: string): Promise<void> {
    await axios.put(`${this.baseUrl}/api/${tableName}`, data, await this.requestConfig());
  }

  async delete(data: any, tableName: string): Promise<void> {
    await axios.delete(
      `${this.baseUrl}/api/${tableName}/${getIdColumnFromTable(data, tableName)}`,
      await this.requestConfig(),
    );
  }
}
